/** @format */
import React, { PropsWithChildren } from 'react';
import styled, { css } from 'styled-components';

import { theme } from '@toucan/client/global/theme';

export enum CardVariant {
    CHILD_SUBTLE = 'child-subtle',
    DEFAULT = 'default',
}

export const StyledCard = styled.div<{ $variant: CardVariant }>`
    ${({ $variant }) => {
        switch ($variant) {
            case CardVariant.CHILD_SUBTLE:
                return css`
                    ${theme.typography.body_normal_highlight}
                    background-color: var(--colors-surface-secondary);
                    border-radius: var(--layout-spacing-4);
                    padding: 0 var(--layout-spacing-12);
                `;
            case CardVariant.DEFAULT:
            default:
                return `
                    padding: var(--layout-spacing-24);
                    background-color: var(--colors-surface-primary);
                    border-radius: 0.8rem;
                    box-shadow: var(--effects-shadow-base);
                `;
        }
    }}
`;

export type CardProps = PropsWithChildren<{
    variant?: CardVariant;
    'data-testid'?: string;
    className?: string;
}>;

export const Card = ({
    variant = CardVariant.DEFAULT,
    'data-testid': dataTestid,
    children,
    ...otherProps
}: CardProps) => {
    return (
        <StyledCard $variant={variant} data-testid={dataTestid} {...otherProps}>
            {children}
        </StyledCard>
    );
};
